import { paginationParams } from "@/utils/pagination";
import request from "@/utils/request";
import { cleanObjectFromUndefined } from "@/utils/utils";

const customSortingKeys = ["hasTWIC", "hasEModal", "isVerified"];

export async function getAllUsers({
  page = 1,
  pageSize = 10,

  city,
  verified,
  hasTWIC,
  hasEModal,
  isActive,
  isShared,
  userType,
  filter = "",
  roleId,
  organizationUnitId,
  userName,
  phoneNumber,
  email,
  firstName,
  lastName,
  isLockedOut,

  notActive,
  emailConfirmed,
  isExternal,
  maxCreationTime,
  minCreationTime,
  maxModificationTime,
  minModificationTime,
  sorting,
  tagIds,
}) {
  const { SkipCount, MaxResultCount } = paginationParams(page, pageSize);
  let Sorting;
  let CustomSorting;

  if (typeof sorting === "string" && sorting.indexOf(":") !== -1) {
    const [sortBy, sortOrder] = sorting.split(":");

    if (customSortingKeys.indexOf(sortBy) !== -1) {
      CustomSorting = `${sortBy.slice(0, 1).toUpperCase() + sortBy.slice(1, sortBy.length)} ${sortOrder}`;
    } else {
      Sorting = `${sortBy} ${sortOrder}`;
    }
  }

  const params = cleanObjectFromUndefined({
    SkipCount,
    MaxResultCount,

    City: city,
    IsVerified: verified,
    HasTwic: hasTWIC,
    HasEModal: hasEModal,
    IsActive: isActive,
    IsShared: isShared,
    Type: userType,
    Filter: filter || undefined,
    RoleId: roleId,
    OrganizationUnitId: organizationUnitId,
    UserName: userName,
    PhoneNumber: phoneNumber,
    EmailAddress: email,
    Name: firstName,
    Surname: lastName,
    IsLockedOut: isLockedOut,
    NotActive: notActive,
    EmailConfirmed: emailConfirmed,
    IsExternal: isExternal,
    MaxCreationTime: maxCreationTime,
    MinCreationTime: minCreationTime,
    MaxModifitionTime: maxModificationTime,
    MinModifitionTime: minModificationTime,
    Sorting,
    CustomSorting,
    TagIds: tagIds,
  });

  try {
    const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/identity-service/users`, {
      method: "GET",
      params,
    });
    return result?.data;
  } catch (error) {
    return {
      items: [],
      totalCount: 0,
    };
  }
}

export async function createUser(data) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/identity-service/users`, {
    method: "POST",
    data,
  });

  if ("error" in result) {
    throw new Error(result?.error);
  }

  return result?.data;
}

export async function updateUser(userId, data) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/identity-service/users/${userId}`, {
    method: "PUT",
    data,
  });

  if ("error" in result) {
    throw new Error(result.error.message);
  }

  return result?.response?.ok;
}

export async function getUserById(userId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/identity-service/users/${userId}`, {
    method: "GET",
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result.data;
}

export async function updateProfilePhoto({ userId, profilePhotoUri }) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/identity-service/users/${userId}/profile-photo`, {
    method: "PATCH",
    params: {
      profilePhotoUri,
    },
  });

  return result?.data;
}

export async function toggleUserActivate(params) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/identity-service/users/toggle-active`, {
    method: "PATCH",
    data: params,
  });

  return result?.data;
}

export async function unlockUser(userId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/identity/users/${userId}/unlock`, {
    method: "PUT",
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result.data;
}

export async function resetUserPassword(params) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/identity-service/users/change-password`, {
    method: "PATCH",
    data: {
      id: params.userId,
      newPassword: params.newPassword,
    },
  });
  return result;
}

export async function forgotPassword(params) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/identity-service/user-management/forgot-password`, {
    method: "POST",
    data: params,
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result;
}

export async function verifyUserEmail(params) {
  const result = await request(
    `${REACT_APP_API_BASE_URL_NEW}/api/identity-service/user-management/verify-email-confirmation-token`,
    { method: "POST", data: params },
  );
  return result;
}

export async function resetPasswordUser(params) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/identity-service/user-management/reset-password`, {
    method: "POST",
    data: params,
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result;
}

export async function requestProfileChanges(data) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/identity-service/user-management/request-profile`, {
    method: "POST",
    data,
  });

  if ("error" in result) {
    throw new Error(result?.error);
  }

  return result;
}

export async function requestUserDeletion(reason) {
  const result = await request(
    `${REACT_APP_API_BASE_URL_NEW}/api/identity-service/user-management/request-user-delete`,
    {
      method: "POST",
      data: {
        reason,
      },
    },
  );

  return result?.data;
}

export async function resendInvitation(userId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/identity-service/users/resend-invite/${userId}`, {
    method: "POST",
    data: {},
  });

  return result.data;
}
